// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: center; /* 水平置中 */
    align-items: center; /* 垂直置中 */
}
  
.background-image {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0; /* 确保背景图片在最底层 */
}

.question-section {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1; /* 确保问题部分在背景图片之上 */
    text-align: center; /* 确保文字水平置中 */
    font-size: 64px;
  
}

.answer-section {
    position: relative;
    z-index: 1; /* 确保答案部分在背景图片之上 */
    text-align: center; /* 确保文字水平置中 */
    display: flex; /* 使用 flexbox 布局 */
    justify-content: space-around; /* 按钮水平分布 */
    width: 100%; /* 确保 flexbox 占满整个容器 */

    
}

.answer-section button {
    font-size: 32px !important; /* 强制应用字体大小 */
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
}

.fade-out {
  opacity: 0;
  transition: opacity 10s ease-out; /* 将动画持续时间延长到10秒 */
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Game2.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB,EAAE,SAAS;IAClC,mBAAmB,EAAE,SAAS;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU,EAAE,eAAe;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU,EAAE,kBAAkB;IAC9B,kBAAkB,EAAE,aAAa;IACjC,eAAe;;AAEnB;;AAEA;IACI,kBAAkB;IAClB,UAAU,EAAE,kBAAkB;IAC9B,kBAAkB,EAAE,aAAa;IACjC,aAAa,EAAE,kBAAkB;IACjC,6BAA6B,EAAE,WAAW;IAC1C,WAAW,EAAE,sBAAsB;;;AAGvC;;AAEA;IACI,0BAA0B,EAAE,aAAa;IACzC,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,UAAU;EACV,gCAAgC,EAAE,kBAAkB;AACtD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    justify-content: center; /* 水平置中 */\n    align-items: center; /* 垂直置中 */\n}\n  \n.background-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 0; /* 确保背景图片在最底层 */\n}\n\n.question-section {\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1; /* 确保问题部分在背景图片之上 */\n    text-align: center; /* 确保文字水平置中 */\n    font-size: 64px;\n  \n}\n\n.answer-section {\n    position: relative;\n    z-index: 1; /* 确保答案部分在背景图片之上 */\n    text-align: center; /* 确保文字水平置中 */\n    display: flex; /* 使用 flexbox 布局 */\n    justify-content: space-around; /* 按钮水平分布 */\n    width: 100%; /* 确保 flexbox 占满整个容器 */\n\n    \n}\n\n.answer-section button {\n    font-size: 32px !important; /* 强制应用字体大小 */\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n}\n\n.fade-out {\n  opacity: 0;\n  transition: opacity 10s ease-out; /* 将动画持续时间延长到10秒 */\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
